import { render, staticRenderFns } from "./WoMemo.vue?vue&type=template&id=47c3725d&scoped=true&"
import script from "./WoMemo.vue?vue&type=script&lang=ts&"
export * from "./WoMemo.vue?vue&type=script&lang=ts&"
import style0 from "./WoMemo.vue?vue&type=style&index=0&id=47c3725d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c3725d",
  null
  
)

export default component.exports